import client from "../client";

export interface SendOTPUpdateBankRequest {
  tel?: string;
  prefix: string;
}

export interface SendOTPUpdateBankResponse {
  data?: SendOTPUpdateBankResponseData;
}

export interface SendOTPUpdateBankResponseData {
  status?: string;
  token?: string;
}

export default function API(
  request: SendOTPUpdateBankRequest
): Promise<SendOTPUpdateBankResponse> {
  return client
    .post(`members/send_otp_update_bank`, request)
    .then((response) => response.data);
}
